import {Slot} from '@radix-ui/react-slot';
import {cva, type VariantProps} from 'class-variance-authority';
import * as React from 'react';

import {cn} from '@/lib/utils';

const buttonVariants = cva(
  'inline-flex items-center justify-center rounded-[0.4rem] text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
  default: 'bg-primary text-primary-foreground hover:bg-[#5C9CF5] active:bg-[#86B9FB]',
        success: 'bg-success text-primary-foreground hover:bg-success-alert-foreground',
        destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
        outline: 'btn-outline',
  secondary: 'border border-[#5C9CF5] text-[#5C9CF5] bg-transparent hover:bg-[#5C9CF5] hover:text-[#17171A] active:bg-[#86B9FB] active:text-[#17171A]',
  ghost: 'hover:bg-accent hover:text-accent-foreground',
  link: 'border border-[#5C9CF5] text-[#5C9CF5] bg-transparent hover:bg-[#5C9CF5] hover:text-[#17171A] active:bg-[#86B9FB] active:text-[#17171A]',
      },
      size: {
        default: 'h-10 px-[16px] py-[10px]',
        sm: 'h-9 rounded-md px-3',
        lg: 'h-11 rounded-md px-8',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({className, variant = 'default', size, asChild = false, ...props}, ref) => {
    const Comp = asChild ? Slot : 'button';
    return <Comp className={cn(buttonVariants({variant, size, className}))} ref={ref} {...props} />;
  },
);
Button.displayName = 'Button';

export {Button, buttonVariants};
